export const event = [
               {
                              id: 1,
                              img: 'https://labartisan.net/demo/kidsacademy/images/event/event_01.jpg',
                              date: `25`,
                              month: 'March',
                              class: 'Imagination Classes',
                              time: '08:00 am - 10:00 am',
                              address: '218 New Newyork Road Newyork',
                              Desc: 'Dratcaly novate fuly rarched an plication awesome theme education that plication creative theme education.'
               },
               {
                              id: 2,
                              img: 'https://labartisan.net/demo/kidsacademy/images/event/event_02.jpg',
                              date: `15`,
                              month: 'August',
                              class: 'Imagination Classes',
                              time: '10:00 am - 1:00 pm',
                              address: '218 New Newyork Road Newyork',
                              Desc: 'Dratcaly novate fuly rarched an plication awesome theme education that plication creative theme education.'
               },
               {
                              id: 3,
                              img: 'https://labartisan.net/demo/kidsacademy/images/event/event_03.jpg',
                              date: `5`,
                              month: 'April',
                              class: 'Imagination Classes',
                              time: '10:00 am - 1:00 pm',
                              address: '218 New Newyork Road Newyork',
                              Desc: 'Dratcaly novate fuly rarched an plication awesome theme education that plication creative theme education.'
               },
]